import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const propTypes = {
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

const ListingCardTemplateLink = ({
  linkTo,
  disabled,
  onClick,
  children,
  ...props
}) => {
  return (
    <Link
      key={linkTo}
      to={linkTo}
      className="listing-card-template-link"
      onClick={event => {
        if (disabled) {
          event.preventDefault();
        }

        onClick?.(event);
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

ListingCardTemplateLink.propTypes = propTypes;

export default ListingCardTemplateLink;
